<template>
  <ion-item-divider v-if="fields.length > 0" color="light">
    <ion-label slot="start"><strong>Meetvelden</strong></ion-label>
    <ion-label slot="end" class="ion-text-end mr-5">
      <small class="light-label">{{ revision_info }}</small>
    </ion-label>
  </ion-item-divider>

  <ion-list :inset="true" lines="inset" class="mt-2">
    <template v-for="field in fields" :key="field.uuid">
      <ion-item :disabled="disabled"  lines="inset">
        <ion-label :position="field.type != 'boolean' ? 'stacked' : null">
          {{ field.label }} <small v-if="field.rules && field.rules.length > 0 && !field.manual_override">
            (automatisch berekend)
          </small>
        </ion-label>
        <template
          v-if="field.manual_override != false || (field.rules && field.rules.length == 0 && field.manual_override == false)">
          <ion-input v-if="field.type == 'text'" v-model="field.value"
            :placeholder="field.placeholder ? field.placeholder : 'Vul waarde in'"></ion-input>
          <template v-else-if="field.type == 'float'">
            <ion-input inputmode="tel" type="tel" v-model="field.value"
              @input="onNumberInput($event, field)"
              :placeholder="field.placeholder ? field.placeholder : 'Vul waarde in'"></ion-input>
          </template>
          <template v-else-if="field.type == 'date'">
            <ion-datetime-button presentation="date" datetime="datetime"></ion-datetime-button>
            <ion-modal :keep-contents-mounted="true">
              <ion-datetime presentation="date" :value="field.value" id="datetime" showDefaultButtons
                @ionInput="field.value = $event.detail.value" cancelText="Annuleren"
                doneText="Bevestigen"></ion-datetime>
            </ion-modal>
          </template>
          <template v-else-if="field.type == 'boolean'">
            <ion-toggle slot="end" v-model="field.value" :binary="true" />
          </template>
          <template v-else-if="field.type == 'select'">
            <ion-select mode="ios" okText="Kies" cancelText="Annuleren" v-model="field.value">
              <ion-select-option :value="option.value" v-for="(option, index) in field.options" :key="index">
                {{ option.label }}</ion-select-option>
            </ion-select>
          </template>
        </template>
        <div class="small-meas-badge"
          v-else-if="field.manual_override == false && field.rules && field.rules.length > 0">
          {{ field.value ? parsed(field.value) : 'Nog niet berekend' }}
        </div>
      </ion-item>
      <div slot="slot" class="manual-mode-button" v-ripple v-if="field.rules && field.rules.length > 0"
        @click.stop="setManualOverride(field)">
        <mdicon name="pencil" v-if="!field.manual_override" />
        <mdicon name="pencil-off" v-else />
      </div>
    </template>
  </ion-list>
</template>

<script>
import { db } from '@/services/db.js';
import _ from 'lodash';
import { handleNumberInput } from '@/utils/numberFormatter.js';

export default {
  name: "calculator-fields",
  props: ["rules", "disabled", "measurement_type_revision_id", "measurement_type_id", "inspection_id", "revision_info", "measurement_revisions"],
  data() {
    return {
      fields: [],
      popoverEvent: null,
    };
  },
  emits: ["updateFields"],
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        let measurement_type_revision;
        
        // Check if existing measurement has a stored revision_id
        if (this.rules && this.rules.revision_id) {
          // Use the stored revision_id to get the exact revision
          measurement_type_revision = await db.measurement_type_revisions.where('id').equals(this.rules.revision_id).first();
        }
        
        // If no stored revision or not found, fall back to inspection's current revision
        if (!measurement_type_revision) {
          // get correct measurement type revision
          const inspection = await db.inspections.get(this.$store.getters.getInspectionId);

          let measurement_type_revisions = await db.measurement_type_revisions.toArray();
          measurement_type_revisions = measurement_type_revisions.filter((mtr) =>
            inspection.measurement_type_revisions.some((imtr) => imtr.id === mtr.id)
          );

          measurement_type_revision = measurement_type_revisions.find(
            (mtr) => mtr.measurement_type_id === this.measurement_type_id
          );
          // end get correct measurement type revision
        }

        if (measurement_type_revision) {
          this.fields = [...this.rules.fields];
          let meas_rules = measurement_type_revision.rules;

          this.fields = this.fields.map(field => {
            let o_field = meas_rules.fields.find(o_field => o_field.uuid === field.uuid);
            if (o_field) {
              return {
                ...field,
                rules: o_field.rules,
                placeholder: o_field.placeholder
              };
            }
            return field;
          });
        }
      } catch (error) {
        console.error("Setup failed:", error);
      }
    },
    setManualOverride(field) {
      field.manual_override = !field.manual_override;
      this.$toast.success(field.manual_override ? "Handmatig invoeren" : "Automatisch berekend");
    },
    parsed(value) {
      if (value == null) return null;
      if (typeof value == "string") return value;
      if (typeof value == "number") {
        return this.formatNumber(value, 2);
      }
      return value;
    },
    formatNumber(value, decimals) {
      const parts = value.toFixed(decimals).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      parts[1] = parts[1].replace(".", ",");
      return parts.join(",");
    },
    emitCleanFields() {
      let fields = [...this.fields];
      this.$emit("updateFields", fields);
    },
    onNumberInput(event, field) {
      handleNumberInput(event, (value) => {
        field.value = value;
      });
    }
  },
  watch: {
    revision_info: function (newVal, oldVal) {
      this.setup();
    },
    fields: {
      handler: _.debounce(function () {
        this.emitCleanFields();
      }, 300), // Zorgt ervoor dat wijzigingen pas na 300ms doorgevoerd worden
      deep: true
    }
  }
};
</script>
